import { useEffect, useState } from "react"
import Button from "../../../button/button"
import InputAnimated from "../../../inputAnimated/inputAnimated"
import InputDate from "../../../inputDate/inputDate"
import Modal from "../../../modal/modal"
import Select from "../../../select/select"
import './AddSpecialDate.scss'
import { GetSpecialDateList, PostAddSpecialDate } from "../../../../utils/Apis/apis"
import { formatToLocalDate } from '../../../../utils/dateTimeZone'

const AddSpecialDate = ({ onClose, isOpen, showAlert }) => {
    const [eventTypeSelected, setEventTypeSelected] = useState('');
    const [eventList, setEventList] = useState([])
    const [dateSelected, setDateSelected] = useState({})
    const [resetKey, setResetKey] = useState(false);
    const [disableButton, setDisabledButton] = useState(false)
    useEffect(() => {
        if (isOpen) {
            const controller = new AbortController();

            const fetchData = async () => {
                try {
                    const specialDates = await GetSpecialDateList();
                    if (controller.signal.aborted) return;
                    if (specialDates.status === 200 && specialDates.result) {
                        const formatted = specialDates.result.map((item) => ({
                            value: item.id,
                            label: item.name
                        }));

                        setEventList(formatted); // 🔄 Ya en formato { value, label }
                    }
                } catch (error) {
                    console.error("❌ Error al cargar fechas especiales", error);
                }
            };

            fetchData();

            return () => controller.abort(); // limpieza
        }
    }, []);
    const handleEventTypeChange = (value) => {
        setEventTypeSelected(value);
        setDateSelected({})
        handleReset()
    }

    const handleDateSelected = (date) => {
        const detect = detectDateType(date)
        setDateSelected(detect)
    }

    function detectDateType(input) {
        // Si es un Date válido, lo tratamos como un 'day'
        if (input instanceof Date && !isNaN(input.getTime())) {
            return {
                type: 'day',
                start_date: formatToLocalDate(input),
                end_date: ''
            };
        }

        if (typeof input !== 'string') return 'unknown';

        // Si contiene " - ", es un rango (semana)
        if (input.includes(" - ")) {
            const [startStr, endStr] = input.split(" - ");

            const parseToISO = (str) => {
                const spanishToEnglishMonth = {
                    'ene': 'Jan',
                    'feb': 'Feb',
                    'mar': 'Mar',
                    'abr': 'Apr',
                    'may': 'May',
                    'jun': 'Jun',
                    'jul': 'Jul',
                    'ago': 'Aug',
                    'sept': 'Sep',
                    'oct': 'Oct',
                    'nov': 'Nov',
                    'dic': 'Dec'
                };

                const parts = str.trim().toLowerCase().split(" ");
                if (parts.length !== 3) throw new Error("Formato de fecha inválido");

                const [day, mes, year] = parts;
                const month = spanishToEnglishMonth[mes];
                if (!month) throw new Error("Mes no reconocido: " + mes);

                const formattedDate = `${day} ${month} ${year}`; // ej: 14 Jul 2025
                const date = new Date(formattedDate);
                if (isNaN(date)) throw new Error("Fecha inválida: " + formattedDate);

                return formatToLocalDate(date);
            };

            return {
                type: 'week',
                start_date: parseToISO(startStr),
                end_date: parseToISO(endStr)
            };
        }

        return 'unknown';
    }

    const handleReset = () => {
        setResetKey(!resetKey)
    }
    const handleConfirm = async () => {
        if (Object.keys(dateSelected).length === 0) {
            return showAlert('info', 'Seleccione una fecha especial');
        }

        try {
            const res = await PostAddSpecialDate(
                eventTypeSelected,
                dateSelected.start_date,
                dateSelected.end_date
            );
            if (res.status === 200) {
                setDisabledButton(true)
                showAlert('success',
                    res.message
                );
                setTimeout(() => {
                    setDisabledButton(false)
                    setEventTypeSelected('');
                    setResetKey(!resetKey);
                }, 3000);
            } else {
                showAlert('warning',
                    res.message
                );
            }
        } catch (err) {
            showAlert('danger', 'Error al guardar la fecha especial');
        }
    };
    return (
        <Modal onClose={onClose} isOpen={isOpen} overlayClick={false}>
            <div className="add-special-date">
                <h1 className="title-1">Añadir fecha especial a calendario</h1>
                <div className="special-date-contain">
                    <Select options={eventList} classN={'main-color'} placeholder={'Selecciona el tipo de fecha'} value={eventTypeSelected} onChange={(e) => handleEventTypeChange(e.target.value)}></Select>
                    {
                        eventTypeSelected === '1' || eventTypeSelected === '2' ? <InputDate selectionType={'week'} placeholder='Selecciona el rango de semana' onChange={(date) => handleDateSelected(date)} resetKey={resetKey} /> : <InputDate selectionType={'date'} placeholder='Selecciona fecha especial' onChange={(date) => handleDateSelected(date)} resetKey={resetKey} />
                    }
                </div>
                <div className='confirm-buttons-section'>
                    <Button backgroundColor="red" text="Cancelar" onClick={onClose} />
                    <Button backgroundColor="blue" text="Confirmar" disabled={!eventTypeSelected || disableButton && true} onClick={handleConfirm} />
                </div>
            </div>
        </Modal>
    )
}
export default AddSpecialDate;